export function handleAccordionHeadClick(e) {
    const $accordionHead = $(e.currentTarget);

    $accordionHead.siblings('.accordion-body').toggleClass('d-none');
    $accordionHead.children('i').toggleClass('icon-arrow-down icon-arrow-up');
}